module.exports = __webpack_public_path__ + "assets/media/empty-clickmap.efc159cc.svg";